const Data = {
    menuItems: [
      {
        name: "Inicio",
        path: "inicio",
        offset: "-120",
      },
      {
        name: "Servicios",
        path: "service",
        offset: "-120",
      },
      {
        name: "Contáctanos",
        path: "about",
        offset: "-100",
      },
      {
        name: "Blog",
        path: "blog",
        offset: "-100",
      }
    ],
  }
export default Data;